export class ApiError extends Error {
    details;
    constructor(message, details) {
        super(message);
        this.name = 'ApiError';
        this.details = details;
    }
}
